<div class="vertical-banner">
  <!-- <img src="./api/services/DownloadCloudResource/{{this.promotionList[0]?.cloudFileName}}"> -->
  <!-- <owl-carousel #owlBanner
    [options]="{items: 1, dots: false, navigation: false, loop: true, autoplay:true, autoplayTimeout:5000, autoplayHoverPause:true, callbacks: true, onChange: bannerChanged, data: bannerChanged2}"
    [items]="bannerList" [carouselClasses]="['owl-theme', 'row', 'sliding']"
    (change)="getData($event)">
    <div class="item" *ngFor="let banner of bannerList;let i = index" id="{{banner.id}}" (click)="onBannerClicked(banner.id)">
      <img src="./api/services/DownloadCloudResource/{{banner.cloudFileName}}" />
    </div>
  </owl-carousel> -->


  <!-- <ngb-carousel *ngIf="bannerList" (slide)="onSlide($event)" wrap="true"  > -->
  <ngb-carousel *ngIf="bannerList.length > 0" (slide)="onSlide($event)" [wrap]="true"  >
    <ng-template ngbSlide *ngFor="let banner of selectedBannerList;let i = index" >
      <!-- <a href="{{banner.promotionLink}}" target="_blank" > -->
      <!-- <img *ngIf="!banner.isBannerDirectUrl" src="https://marketingdd.blob.core.windows.net/marketing/{{banner.cloudFileName}}" (click)="onBannerClicked(banner.id)"/>  -->
      <!-- <img [src]="banner.isBannerDirectUrl ? banner.cloudFileName: 'https://marketingdd.blob.core.windows.net/marketing/' + banner.cloudFileName | sanitizeUrl" (click)="onBannerClicked(banner.id)" />  -->
      <!-- <iframe  *ngIf="banner.isBannerDirectUrl" class="iframeVerticalBanner" [src]="banner?.cloudFileName | sanitizeUrl" (click)="onBannerClicked(banner)"> </iframe> -->
      <div style="width: 100%;position: relative;"  *ngIf="displayDirectUrl(banner); else directLinkUrl">
                  <iframe   class="iframeVerticalBanner" 
                        [src]="banner.cloudFileName | sanitizeUrl" >
                </iframe>
        <div style="position: absolute;top:20px;left:5px;width:100%;height:100%; background:transparent" class="bar" (click)="onBannerClicked(banner)"></div>
        </div> 
        <ng-template #directLinkUrl>
          <div  (click)="onBannerClicked(banner)">
                  <img src="https://marketingdd.blob.core.windows.net/marketing/{{banner?.cloudFileName}}" />
          </div>
  </ng-template>
    <!-- </a> -->
    </ng-template>
  </ngb-carousel>
</div>
